import { t } from '@gem/modules/i18n';
import {
  getFixedSizeBlurredImage,
  getFullScreenImage,
  getImageByLargestSize,
} from '@gem/modules/image-resizer';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { FilePayload } from '../FilePayload/FilePayload';

export class ImagePayload extends FilePayload {
  graphicSize;
  stretchedByWidth;

  static MIN_IMAGE_MESSAGE_WIDTH = 100;
  static MIN_IMAGE_MESSAGE_HEIGHT = 40;

  static MIN_FORWARD_IMAGE_MESSAGE_WIDTH = 200;

  constructor(data) {
    super(data);

    this.payloadType = PayloadType.Image;
    this.graphicSize = data.graphicSize || {};
    this.localPreview = data.localPreview;
    this.stretchedByWidth = data.stretchedByWidth;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      graphicSize: this.graphicSize,
      stretchedByWidth: this.stretchedByWidth,
      localPreview: this.localPreview,
    };
  }

  get originUrl() {
    return this.localPreview || getFullScreenImage(this.url);
  }

  get placeholderUrl() {
    return this.localPreview
      ? null
      : getFixedSizeBlurredImage(
          this.url,
          {
            width: FilePayload.PREVIEW_MAX_WIDTH,
            height: 0, //scaled by width
          },
          this.graphicSize
        );
  }

  get hasPlaceholder() {
    return Boolean(this.placeholderUrl);
  }

  get previewUrl() {
    return this.localPreview || getImageByLargestSize(this.url, FilePayload.PREVIEW_MAX_WIDTH);
  }

  get previewSize() {
    const { width, height } = this.graphicSize;

    if (!width || !height) {
      return { width, height };
    }
    return FilePayload.calculatePreviewSize(
      width,
      height,
      FilePayload.PREVIEW_MAX_WIDTH,
      FilePayload.PREVIEW_MAX_HEIGHT
    );
  }

  get typeDescription() {
    return t('message_desctription_picture');
  }
}
